import { useEffect, useRef, useState } from "react";

import { TreeItem, SimpleTreeView } from "@mui/x-tree-view";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import itemHrchyService from "@plannel/services/data/item-hrchy-service";

import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { DoneAll } from "@mui/icons-material";
import debug from "@plannel/utils/debug-util";
import TextField from "@mui/material/TextField";

import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, FormControlLabel, Checkbox, FormControl, Popover, InputAdornment, Button, Divider } from "@mui/material";

import reduxUtil from "@plannel/utils/redux-util";
import { size, isEmpty, isEqual, isArray } from "lodash";
const ITEM_HRCHY = "ITEM_HRCHY";

/**
 * @param {object} props viewName, onChangeFilter, excludeAllFilters, hideFilters
 * @param {function} onChangeFilter setFilterValue ** required value
 * @param {String} viewName viewName ** required value
 * @param {boolean} hide hide
 * @param {boolean} enableSelectParent enableSelectParent // ex) BF Forecast Review, RP Review
 * @param {object[]} selectedItem itemSearch :: for item select case // ex) BF Forecast Review
 * @param {boolean} unuseClearIcon unuseClearIcon
 * @param {object[]} defaultValue defaultValue :: itemHrchyDto // ex) BfForecastReview
 * @param {Integer} hrchyNumFilter hrchyNum
 * @param {object} styles { width: 200 }
 * @param {boolean} reload reload
 * @param {boolean} enableMultiSelect enableMultiSelect
 * @param {object[]} customValue customValue :: for value setting customize ex) DP Workbench
 * @param {String} label for InputField label value customize ex) DP Workbench, BF Review
 * @param {boolean} dispatch for case where redux state declared as dispatch ex) IP AnalysisFilter, RP Filters
 * @param {boolean} selectLeafs in multi select, selects all leaf nodes when a parent node is selected. ex) RP Monthly Trend
 */

const ItemHrchyTreeFilter = props => {
  const { viewName, onChangeFilter, hide, enableSelectParent, selectedItem, unuseClearIcon, defaultValue, hrchyNumFilter, styles, treeload, enableMultiSelect, customValue, label, dispatch, selectLeafs, disabled } = props;
  const hideFilter = hide?.find(el => el === "category") ?? false;
  const parentSelectable = enableSelectParent === true ? enableSelectParent : false;
  const viewClearIcon = unuseClearIcon === true ? !unuseClearIcon : true;
  const treeItemList = selectedItem || [];
  const multySelectable = enableMultiSelect === true ? enableMultiSelect : false;
  const selectChild = selectLeafs === true ? selectLeafs : false;

  const { t } = useTranslation();
  const [tree, setTree] = useState([]);
  // const [hrchyCdRenderText, setHrchyCdRenderText] = useState("");
  const [hrchyCdState, setHrchyCdState] = useState(reduxUtil.getViewState(viewName)?.filter?.item?.code ? reduxUtil.getViewState(viewName).filter?.item.code : reduxUtil.getViewState(viewName)?.filter?.category?.hrchyCd ?? "");
  const categoryFilter = reduxUtil.getViewState(viewName)?.filter?.category ?? "";
  const [hrchyCdText, setHrchyCdText] = useState(
      !isArray(categoryFilter) ? categoryFilter?.name ?? ""  : categoryFilter?.map(itemHrchy => itemHrchy?.name).join(",") ?? ""
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [hoveredItem, setHoveredItem] = useState("");

  const open = Boolean(anchorEl);
  const reduxDispatch = useDispatch();
  const inputRef = useRef(null);

  const [checkSelected, setCheckSelected] = useState(reduxUtil.getViewState(viewName)?.filter?.category || []);
  const FILTER_CATEGORY = "filterCategory";

  const getAllDescendants = node => {
    const allDescendants = [];

    const addChild = child => {
      allDescendants.push(child);
      if (child?.children) {
        child.children.forEach(descend => {
          addChild(descend);
        });
      }
    };

    addChild(node);
    return allDescendants;
  };

  useEffect(() => {
    if (!multySelectable) {
      const itemHrchyReduxViewState = reduxUtil.getViewState(ITEM_HRCHY);
      const itemHrchy = itemHrchyReduxViewState?.itemHrchy ?? getAllDescendants(tree);
      const hrchy = !parentSelectable ? itemHrchy?.filter(data => data.leafFlg && data?.hrchyCd === hrchyCdState) : itemHrchy?.filter(data => data?.hrchyCd === hrchyCdState);
      if (dispatch) {
        dispatch({ type: FILTER_CATEGORY, value: hrchy.length > 0 ? hrchy[0] : null });
      } else {
        const reduxViewState = reduxUtil.getViewState(viewName);
        const filterValue = reduxViewState?.filter ?? {};
        const item = treeItemList.filter(data => data.code === hrchyCdState);
        onChangeFilter({ ...filterValue, category: hrchy.length > 0 ? hrchy[0] : null, item: item.length > 0 ? item[0] : null });
        const reduxState = reduxUtil.createFilterViewState(viewName, { ...filterValue, category: hrchy.length > 0 ? hrchy[0] : null, item: item.length > 0 ? item[0] : null });
        reduxDispatch(reduxUtil.updateViewState(reduxState));
        setAnchorEl(null);
      }
      if (hrchy.length > 0) {
        setIsSelected(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hrchyCdState]);

  const checkNullArray = (values) => {
    if (!values) {
      return null;
    }
     if (isArray(values) && (isEmpty(values[0]) || values[0] === null)) {
       return [];
     }
    return isArray(values) ? values : [values];
  };

  const setItemHrchysState = selectList => {
    const reduxViewState = reduxUtil.getViewState(viewName);

    const filterValue = reduxViewState?.filter ?? {};

    const checkSelectedArray = checkNullArray(selectList) || checkNullArray(checkSelected);
    if (checkSelectedArray) {
      const filterArrays = isArray(filterValue) ? filterValue : [filterValue];
      const filterHrchyCds = filterArrays?.category?.map(val => val.hrchyCd);
      const checkedHrchyCds = checkSelectedArray.map(val => val.hrchyCd);
      
      if (!isEqual(filterHrchyCds, checkedHrchyCds)) {
        // 중복 제거 (hrchyCd 또는 id 기준)
        const dedupedArray = isArray(checkSelectedArray)
          ? checkSelectedArray.filter(v => v).reduce((acc, cur) => {
              const key = cur?.hrchyCd ?? cur?.id;
              if (key === null) return acc;
              if (!acc.some(x => (x.hrchyCd ?? x.id) === key)) {
                acc.push(cur);
              }
              return acc;
            }, [])
          : checkSelectedArray;
        const categorys = enableMultiSelect ? dedupedArray : dedupedArray?.[0] ?? null;

        onChangeFilter({ ...filterValue, category: categorys });
        const reduxState = reduxUtil.createFilterViewState(viewName, { ...filterValue, category: categorys });
        reduxDispatch(reduxUtil.updateViewState({ ...reduxState }));
      }
      setCheckSelected(checkSelectedArray);
  
      if (size(tree) === 0) {
        setHrchyCdText("");
      } else {
        const leafs = checkSelectedArray.filter(itemHrchy => {
          return itemHrchy.leafFlg;
        });
        const visibleArray = size(leafs) > 0 ? leafs : checkSelectedArray;
        const hrchyCdTextValue = visibleArray
          .map(itemHrchy => {
            return itemHrchy?.name;
          })
          .join(",");

        setIsSelected(true);
        setHrchyCdText(hrchyCdTextValue);
      }
    }
  };

  useEffect(() => {
    if (!isSelected) {
      // setHrchyCdRenderText(hrchyCdText);
      if (multySelectable) {
        if (
          hrchyCdText === "" &&
          hrchyCdText !==
            reduxUtil
              .getViewState(viewName)
              ?.filter?.category?.map(itemHrchy => {
                return itemHrchy?.name;
              })
              .join(",")
        ) {
          // 초기 or ""
          if (treeload) {
            if (!selectChild) {
              setHrchyCdText(
                defaultValue
                  .map(itemHrchy => {
                    return itemHrchy?.name;
                  })
                  .join(",")
              );
            } else {
              const leaf = defaultValue?.filter(el => el.leafFlg);
              if (leaf !== null && !isEmpty(leaf)) {
                setHrchyCdText(
                  leaf.map(itemHrchy => {
                    return itemHrchy?.name;
                  })
                    .join(",")
                );
              }
            }
            const reduxViewState = reduxUtil.getViewState(viewName);
            const filterValue = reduxViewState?.filter ? reduxViewState.filter : {};
            onChangeFilter({ ...filterValue, category: defaultValue, itemCheckSelected: defaultValue });
            const reduxState = reduxUtil.createFilterViewState(viewName, { ...filterValue, category: defaultValue, itemCheckSelected: defaultValue });
            reduxDispatch(reduxUtil.updateViewState(reduxState));
          }
        }
      }
    } else {
      setIsSelected(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hrchyCdText]);

  useEffect(() => {
    if (multySelectable) {
      let hrchyList = reduxUtil.getViewState(viewName)?.filter?.category ? reduxUtil.getViewState(viewName)?.filter?.category : defaultValue;
      if (!isArray(hrchyList)) {
        hrchyList = [hrchyList];
      }
      let defaultText="";
      if (!selectChild) {
        defaultText =  defaultValue?.map(itemHrchy => {
            return itemHrchy?.name;
          })
      } else {
        const leaf = defaultValue?.filter(el => el.leafFlg)
        if (leaf !== null && !isEmpty(leaf)) {
          defaultText = leaf
            .map(itemHrchy => {
              return itemHrchy?.name;
            })
            .join(",")
        }
      }
      if (defaultValue) {
        setHrchyCdText(defaultText);
      }
    } else {
      if (reduxUtil.getViewState(viewName)?.filter?.item === null && reduxUtil.getViewState(viewName)?.filter?.category === null && defaultValue) {
        setHrchyCdState(defaultValue?.hrchyCd);
        setHrchyCdText(defaultValue?.name);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  useEffect(() => {
    if (customValue && size(tree) > 0) {
      
      if (!enableMultiSelect) {
        if (!isEqual(customValue?.[0], checkSelected?.[0])) {
          setItemHrchysState(customValue);
        }
      } else {
        setItemHrchysState(customValue);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customValue, tree]);
  
  useEffect(() => {
    if (treeload) {
      if (defaultValue) {
        if (multySelectable) {
          setCheckSelected(!isArray(defaultValue) ? [defaultValue] : defaultValue);
          let defaultText="";
          if (!selectChild) {
            defaultText =  defaultValue
              .map(itemHrchy => {
                return itemHrchy?.name;
              })
          } else {
            const leaf = defaultValue?.filter(el => el.leafFlg)
            if (leaf !== null && !isEmpty(leaf)) {
              defaultText = leaf
                .map(itemHrchy => {
                  return itemHrchy?.name;
                })
                .join(",")
            }
          }
          setHrchyCdText(defaultText);
        } else {
          setHrchyCdState(defaultValue?.hrchyCd);
          setHrchyCdText(defaultValue?.name);
        }
      } else {
        setHrchyCdState("");
        setHrchyCdText("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treeload]);

  const loadCategoryData = () => {
    const itemHrchyData = [];
    itemHrchyService
      .getHrchyFilter({hrchyNum: hrchyNumFilter})
      .then(response => {
        const { results } = response.data;
        if (!isEmpty(results)) {
          itemHrchyData.push(...getAllDescendants(results?.[0]));
          setTree(results?.[0]);
        }
      })
      .catch(e => {
        debug(e);
      })
      .finally(() => {
        const itemHrchyReduxState = reduxUtil.createObjectState(ITEM_HRCHY, { itemHrchy: itemHrchyData });
        reduxDispatch(reduxUtil.updateViewState(itemHrchyReduxState));
      });
  };

  useEffect(() => {
    loadCategoryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hrchyNumFilter]);

  const handleClose = (_e, hrchyCd) => {
    /* 사용자가 아무런 행동도하지 않은채 Close 하는 경우. */
    const noActionCheck = isEqual(checkSelected, categoryFilter);
    if (noActionCheck) {
      setAnchorEl(null);
      
      return;
    }

    if (multySelectable) {
      // for multySelect
      setItemHrchysState();
    } else {
      if (!parentSelectable) {
        const allList = getAllDescendants(tree);
        if (allList.filter(data => data.leafFlg && data.name === hrchyCd).length === 0 && allList.filter(data => data.leafFlg && data.name === hrchyCdText).length === 0) {
          setHrchyCdState("");
          setHrchyCdText("");
        }
      }
    }

    setAnchorEl(null);
  };

  const handleMouseEnter = () => {
    if (disabled) {
      return;
    }
    setIsFocused(true);
  };

  const handleMouseLeave = () => {
    if (disabled) {
      return;
    }
    setIsFocused(false);
  };

  const handleTreeItemHover = (_e, node) => {
    if (enableSelectParent) {
      setHoveredItem(node);
    } else {
      if (node.leafFlg) {
        setHoveredItem(node);
      }
    }
  };

  const getOnChange = (checked, node) => {
    // for multiselect checkbox logic
    const allDescendants = getAllDescendants(node);
    let checkedArray = checked ? [...new Set([...checkSelected, ...allDescendants])] 
      : checkSelected?.filter(value => !allDescendants.some(obj => obj.hrchyCd === value.hrchyCd));

    if (!selectChild) {
      checkedArray = checkedArray?.filter(data => {
        return data.hrchyLv === node.hrchyLv;
      });
    } else {
      if (!checked) {
        checkedArray = checkedArray?.filter(checkedNode => !allDescendants.includes(checkedNode.hrchyCd) && !node.ancester?.includes(checkedNode.hrchyCd));
      } else {
        const checkedHrchyCds = checkedArray.map(hrchy => hrchy.hrchyCd);
        const allList = getAllDescendants(tree).filter(hrchy => hrchy?.descendant.includes(checkedHrchyCds));
        checkedArray = [...new Set([...checkedArray, ...allList])];
      }
    }
    setCheckSelected(checkedArray); // tree render
  };

  const renderTree = node => {
    const children = node?.children;
    //여기문제없음
    const checkedArrays = isArray(checkSelected) ? checkSelected : [checkSelected];
    const checked = checkedArrays?.some(checkedSelect => checkedSelect.hrchyCd === node.hrchyCd);
    const indeterminate = checkedArrays?.some(checkedSelect => node?.descendant?.includes(checkedSelect.hrchyCd)) && !checked;
    return (
      <TreeItem
        itemId={node.hrchyCd}
        key={node.hrchyCd}
        sx={{ boxSizing: "border-box" }}
        label={
          !multySelectable ? (
            <Box
              className={"MuiAutocomplete-popper MuiAutocomplete-noOptions"}
              sx={{
                padding: "5px 8px",
              }}
              onClick={e => {
                if (!parentSelectable) {
                  if (node.leafFlg) {
                    setHrchyCdText(node.name);
                    setHrchyCdState(node.hrchyCd);
                    handleClose(e, node.name);
                  }
                } else {
                  setHrchyCdText(node.name);
                  setHrchyCdState(node.hrchyCd);
                  handleClose(e, node.name);
                }
              }}
              onMouseEnter={event => handleTreeItemHover(event, node)}
              onMouseLeave={() => setHoveredItem(null)}>
              {" "}
              {node.name}{" "}
            </Box>
          ) : (
            <FormControlLabel
              sx={{ width: "95%" }}
              control={
                <Checkbox
                  sx={{ p: 0.5 }}
                  checked={checked}
                  size="small"
                  indeterminate={indeterminate}
                  onChange={event => getOnChange(event.currentTarget.checked, node)}
                  onClick={e => e.stopPropagation()}
                />
              }
              label={
                <Box
                  className={"MuiAutocomplete-popper MuiAutocomplete-noOptions"}
                  sx={{
                    padding: '3px 9px',
                    width: "95%",
                  }}
                  onMouseEnter={event => handleTreeItemHover(event, node)}
                  onMouseLeave={() => setHoveredItem(null)}>
                  {node.name}
                </Box>
              }
              key={node.id}
            />
          )
        }>
        {children?.map(child => renderTree(child))}
      </TreeItem>
    );
  };

  const createTree = itemHrchys => {
    if (!isEmpty(itemHrchys)) {
      const defaultExpandList = [];
      defaultExpandList.push(itemHrchys?.hrchyCd);

      return (
        <Box>
          {isEmpty(itemHrchys) ? (
            <Box
              id={"item-hrchy-tree-list"}
              className={"MuiAutocomplete-popper MuiAutocomplete-noOptions"}
              sx={{
                padding: "8px 16px",
                minWidth: 230,
                color: "#888",
              }}>
              {"No Options"}
            </Box>
          ) : (
            <SimpleTreeView
              id={"hrchy-tree-view"}
              defaultExpandedItems={defaultExpandList}
              sx={{
                maxHeight: 360,
                paddingLeft: "5px",
                paddoverflowY: "auto",
                minWidth: 230,
              }}
              >
              {renderTree(itemHrchys)}
            </SimpleTreeView>
          )}
        </Box>
      );
    }
    return null;
  };

  const handleClick = event => {
    if (disabled) {
      return;
    }
    inputRef.current.focus();
    setAnchorEl(event.currentTarget);
  };

  const handleKeyPress = event => {
    if (disabled) {
      return;
    }

    if (event.key === "Enter" && !multySelectable) {
      if (hoveredItem) {
        setHrchyCdText(hoveredItem.name);
        setHrchyCdState(hoveredItem.hrchyCd);
        inputRef.current?.focus();
        setAnchorEl(null);
      }
    }
  };

  return !hideFilter ? (
    <>
      <FormControl
        className={"item-hrchy-tree-filter"}
        size="small"
        sx={{ mr: 1, minWidth: 230, width: 240, ...styles }}>
        <TextField
          size="small"
          label={label ? t(label) : t("itemHrchy")}
          type="string"
          onKeyDown={e => handleKeyPress(e)}
          onClick={e => handleClick(e)}
          onMouseEnter={() => handleMouseEnter()}
          onMouseLeave={() => handleMouseLeave()}
          disabled={disabled}
          value={hrchyCdText}
          onChange={event => setHrchyCdText(event.target.value)}
          inputRef={inputRef}
          autoComplete="off"
          InputProps={{
            endAdornment:
              hrchyCdText?.length > 0 ? (
                <>
                  {viewClearIcon && isFocused ? (
                    <IconButton
                      size="small"
                      aria-label="clear text"
                      disabled={disabled}
                      onClick={(e) => {
                        e.stopPropagation(); // 부모 onClick 호출 방지
                        setHrchyCdText("");
                        setHrchyCdState("");
                        setItemHrchysState([]);
                      }}>
                      <ClearIcon sx={{ fontSize: "1.2rem" }} />
                    </IconButton>
                  ) : null}
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="search"
                      sx={{ padding: 0 }}
                      disabled={disabled}
                      size="small">
                      {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </IconButton>
                  </InputAdornment>
                </>
              ) : (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="search"
                    disabled={disabled}
                    size="small">
                    {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                  </IconButton>
                </InputAdornment>
              ),
          }}
        />
      </FormControl>
      <Popover
        open={Boolean(open)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        disableAutoFocus
        disableEnforceFocus
        TransitionProps={{ timeout: 0 }}>
        <Box>
          <Box sx={{ minWidth: 180, width: 240, overflowY: "auto", overflowX: "hidden", ...styles }}>{createTree(tree)}</Box>
          {multySelectable ? (
            <Box>
              <Divider sx={{ backgroundColor: "primary.main", borderColor: "primary.main", borderWidth: 0.5, opacity: 0.2 }} />
              <Box
                sx={{
                  padding: "8px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}>
                <Button
                  sx={{ mr: 1.1 }}
                  variant="contained"
                  startIcon={<DoneAll />}
                  size="small"
                  color="primary"
                  onClick={handleClose}>
                  {t("confirm")}
                </Button>
              </Box>
            </Box>
          ) : null}
        </Box>
      </Popover>
    </>
  ) : null;
};

export default ItemHrchyTreeFilter;
